import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {  CompoundField, Field, } from '../../core/inputElements';
import { StepContext, Section, FormContext, RecordContext, MessagePane } from '../../core/layoutElements'; 

import useImportData from '../hooks/use-import-data.hook'

import { DATE_FORMAT, RECLIST_ID_SEP } from '../../../utilities/constant';
import { Id, STEPID, TITLE, part_a_particulars, additional_title, HaveCheque } from '../constants'
import moment from 'moment';

const Particulars = (props) => {
    const { formLocalization, form } = useContext(FormContext);
    const { formData } = useSelector(store => store.formDetail);
    const query = new URLSearchParams(window.location.search);
    const [duplicatedRecords, setDuplicatedRecords] = useState([]);

    const { importDataFromLocalStorge, clearLocalStorage } = useImportData();

    useEffect(() => {
        // Check whether there is any data from LR152 waiting for import
        if(query.get("importData")==="pending") {
            // Import start
            setDuplicatedRecords(importDataFromLocalStorge());

            // Import completed
			query.set("importData", "done");
			const newRelativePathQuery = window.location.pathname + '?' + query.toString();
			window.history.pushState(null, '', newRelativePathQuery);
        }

        // Clear data from LR152
        clearLocalStorage();
    }, [])

    const getWarningMsg = () => {
        const msgList = []
        duplicatedRecords.forEach(p=>{
            if (msgList.length > 0) {
                msgList.push(<br/>);
            }
            msgList.push(formLocalization.formatString(formLocalization.Warn_OrderOfLodgement, p[0],p[1]));
        })

        if (msgList.length > 0) {
            return (
                <MessagePane id="lodListWarning" mode="warning" hideWhen={false}>
                    <p>{ formLocalization.Warn_IdenticalInstrument() }</p>
                    <p>{ msgList }</p>
                </MessagePane>
            )
        }
        else {
            return null
        }
    }

    const idListForInstruments = [Id.NatureOfInstrument, Id.PRN];

    return ( 
        <StepContext.Provider value={{stepId: STEPID, title: TITLE, validations: {}}}>
            { getWarningMsg() }
            <Section id={part_a_particulars} titleText={formLocalization.part_a_particulars} inline={props.inline}>
                <>
                    <Field.Validation id={Id.presetSolicitorCode} validation={[]} />
                    <Field.Validation id={Id.importedData} validation={[]} />
                    <Field.Validation id={Id.dupRec} validation={[]} />
                </>
                <Field.Text id={Id.SolicitorCode} label={formLocalization.SolicitorCode} required exactlength={8} naturalNumberOnly forceUpdateField readonly={(formData[Id.importedData]&&formData[Id.presetSolicitorCode])}/>
                <Field.Text id={Id.NameOfLodgingParty} label={formLocalization.NameOfLodgingParty} required maxlength={140} multiline={true} />
                <Field.DatePicker id={Id.Date} label={formLocalization.Date} defaultDate={moment().format(DATE_FORMAT)} />
                <Field.Dropdown id={Id.HaveCheque} label={formLocalization.HaveCheque} required options={formLocalization.field_HaveCheque_list} />
                <Field.Text id={Id.NoOfCheques} label={formLocalization.NoOfCheques} required integeronly decimalMin={1} maxlength={4} 
                            hideWhen={(formData[Id.HaveCheque] !== HaveCheque.YES)} />
                <Field.Text id={Id.TotalAmount} label={formLocalization.TotalAmount} required naturalNumberOnly maxlength={6} />

                <CompoundField.RecordList id={additional_title} label={formLocalization.OrderOfLodgement} readOnly={props.readOnly} minrecords={1} maxrecords={300}
                    idListForSwapping={idListForInstruments}
                    template={key => (
                        <RecordContext.Consumer>{({ index }) => (
                            <>
                                <Field.Text id={idListForInstruments[0] + RECLIST_ID_SEP + index} label={formLocalization.NatureOfInstrument} maxlength={100} required />
                                <Field.Text id={idListForInstruments[1] + RECLIST_ID_SEP + index} label={formLocalization.PRN} maxlength={300} required />
                            </>
                        )}</RecordContext.Consumer>
                    )} />
            </Section>
        </StepContext.Provider>
    ) 
};

export default {
    stepId: STEPID,
    title: TITLE,
    content: Particulars,
    focusFirstInput: true,
    validations: {},
};
